import { ProductVariantCopy } from '@/lib/contentful';

export const getVariantTranslation = (
  translations: ProductVariantCopy | null,
  key: string,
) => {
  if (!translations) return key;

  return translations[key] || key;
};
